import {
  bottomRightIcon,
  elementCost,
  pitchElement,
  pitchElementData,
  topLeftIconList,
  topRightIcon,
} from "plos/src/components/ElementCard/ElementCard.css";
import ElementCardButton from "plos/src/components/ElementCard/ElementCardButton";
import ElementName from "plos/src/components/ElementCard/ElementName";
import ElementDialogButton from "plos/src/components/ElementDialogButton";
import ElementShirt from "plos/src/components/ElementShirt";
import { PlayerNotesIcon } from "plos/src/components/playerNotes/PlayerNotesIcon";
import { ElementIconButton } from "plos/src/components/tooltips/ElementIconButton";
import { usePlosTranslations } from "plos/src/contexts/PlosTranslationsContext";
import Cross from "../../../img/icons/cross.svg?react";
import ElementOverlayValue from "../../PitchControls/ElementOverlayValue";
import { cross, elementRemoveButton } from "./elementProposedCard.css";
import { ElementProposedCardProps } from "./types";

const ElementProposedCard = ({
  renderElementMenu,
  elementValue,
  element,
  nextEvent,
  copnr,
  team,
  actionMe,
  pick,
}: ElementProposedCardProps) => {
  const { removePlayer: removePlayerText } = usePlosTranslations();

  return (
    <>
      <ElementCardButton onPress={renderElementMenu}>
        <div className={pitchElement}>
          <span className={elementCost}>{elementValue}</span>
          <ElementShirt
            alt={team.name}
            elementId={element.id}
            sizes="(min-width: 700px) 75px, 56px"
          />
          <div className={pitchElementData.default}>
            <ElementName copnr={element.news ? copnr : null}>
              {element.web_name}
            </ElementName>
            <ElementOverlayValue
              pick={pick}
              eventId={nextEvent?.id}
              elementId={element.id}
            />
          </div>
        </div>
      </ElementCardButton>
      <div>
        <div className={topLeftIconList}>
          <ElementIconButton
            onPress={actionMe}
            label={removePlayerText(element.web_name)}
          >
            <span className={elementRemoveButton}>
              <Cross className={cross} aria-hidden />
            </span>
          </ElementIconButton>
        </div>
        {element.news && (
          <div className={topRightIcon}>
            <ElementDialogButton elementId={element.id} variant="pitch" />
          </div>
        )}
        <div className={element.news ? bottomRightIcon : topRightIcon}>
          <PlayerNotesIcon
            element={element}
            action={renderElementMenu}
            useDarkIconInDarkMode={true}
          />
        </div>
      </div>
    </>
  );
};

export default ElementProposedCard;
